<div class="backdrop" *ngIf="showDropdown" (click)="dropdownHandler()"></div>

<div class="circle-50 circle-50--orange" (click)="dropdownHandler()">
  <img src="../../../../../assets/images/card/more_dots.svg" alt="dots" />
</div>

<div
  class="dropdown-wrapper z-index-200"
  [ngClass]="{ 'dropdown-wrapper--open': showDropdown }"
>
  <div class="dropdown" [ngClass]="{ child: showLeft }">
    <ng-container *ngFor="let nav of navigations">
      <div
        *ngIf="
          (!nav.permission || hasAppPermission(nav.permission)) &&
          (!nav.privilege || hasPrivilege(nav.privilege)) && 
          checkIfLinkVisible(nav)
        "
        class="dropdown__item mb-5 pointer"
        fxLayoutAlign="space-between center"
        [routerLink]="nav.route"
        (click)="
          nav.name === 'Announcements'
            ? announcementHandler()
            : selectAccount(nav)
        "
      >
        <div fxLayout="row">
          <div class="mr-10">
            <span class="link__icon">
              <img
                width="15"
                [src]="'assets/images/page-link/' + nav.icon + '.svg'"
              />
            </span>
          </div>
          <p fxLayoutAlign="center center">{{ nav.name | translate }}</p>
        </div>
        <span class="dropdown__item__icon"></span>
      </div>
    </ng-container>

    <div
      class="dropdown__item pointer"
      fxLayoutAlign="space-between center"
      (click)="refreshBalance()"
    >
      <div fxLayout="row ">
        <div class="mr-10">
          <span class="link__icon">
            <img [src]="'assets/images/page-link/details.svg'" />
          </span>
        </div>
        <p fxLayoutAlign="center center">
          {{ 'ic_option_menu_45' | translate }}
        </p>
      </div>
      <span class="dropdown__item__icon"></span>
    </div>
  </div>
</div>
